module.exports = __webpack_public_path__ + "static/media/bi_check.81ac49cf.svg";